/** Because JS numbers are fun */
export const floatSafeAdd = (a: number, b: number) => {
  const maximumPrecision = Math.max(
    a.toString().split('.')[1]?.length ?? 0,
    b.toString().split('.')[1]?.length ?? 0
  )
  const multiplier = Math.pow(10, maximumPrecision + 2)
  return (a * multiplier + b * multiplier) / multiplier
}
